var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4917 14.5833H13.75C16.2667 14.5833 18.3333 12.525 18.3333 10C18.3333 7.48333 16.275 5.41667 13.75 5.41667H12.4917",
    stroke: "#9C4FFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 5.41667H6.25C3.725 5.41667 1.66667 7.475 1.66667 10C1.66667 12.5167 3.725 14.5833 6.25 14.5833H7.5",
    stroke: "#9C4FFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66667 10H13.3333",
    stroke: "#9C4FFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0,
    d: "M0.416992 19.583L0.416992 0.416992L19.583 0.416992L19.583 19.583L0.416992 19.583Z",
    stroke: "#9C4FFF",
    strokeWidth: 0.833333
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3074981d98052c0a79e41107d90c78f6.svg";
export { ForwardRef as ReactComponent };